enum CHA_LINKS {
  FAQ = 'https://oyster-yaydoo.zendesk.com/hc/es-419',
}

export default CHA_LINKS;
